import { useEffect, useState } from "react";
export var useDimensions = function () {
    var _a = useState({
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth
    }), initialDimensions = _a[0], setInitialDimensions = _a[1];
    var _b = useState({
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth
    }), dimensions = _b[0], setDimensions = _b[1];
    useEffect(function () {
        function handleResize() {
            setDimensions({
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            });
        }
        window.addEventListener('resize', handleResize);
        window.addEventListener('focus', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('focus', handleResize);
        };
    }, []);
    var commonContentPadding = '20px';
    var commonContentPaddingRaw = 20;
    if (dimensions.width < 1500) {
        commonContentPaddingRaw = 16;
        commonContentPadding = '16px';
    }
    if (dimensions.width < 1200) {
        commonContentPaddingRaw = 10;
        commonContentPadding = '10px';
    }
    var availableWithWithoutDrawer = dimensions.width;
    var leftOffsetWithDrawer = DRAWER_WIDTH;
    if (dimensions.width < MIN_WIDTH_TO_SHOW_FULL_DRAWER) {
        availableWithWithoutDrawer -= MIN_WIDTH_TO_SHOW_FULL_DRAWER;
        leftOffsetWithDrawer = 0;
    }
    return {
        width: dimensions.width,
        height: dimensions.height,
        isSmallScreen: dimensions.width <= 600,
        isMediumScreen: dimensions.width > 600 && dimensions.width <= 1400,
        isLargeScreen: dimensions.width > 1400 && dimensions.width <= 1800,
        isExtraLargeScreen: dimensions.width > 1800,
        isTablet: dimensions.width <= 1024,
        isPhone: dimensions.width <= 500,
        initialDimensions: initialDimensions,
        commonContentPadding: commonContentPadding,
        commonContentPaddingRaw: commonContentPaddingRaw,
        availableWithWithoutDrawer: availableWithWithoutDrawer,
        leftOffsetWithDrawer: leftOffsetWithDrawer
    };
};
export var DRAWER_WIDTH = 260;
export var CONTENT_SIDE_PADDING = 0;
export var TABLE_SCHEDULE_LIST_COLLAPSED_WIDTH = 375;
export var TABLE_SCHEDULE_LIST_LAYOUT_SEPARATOR = 10;
export var HEADER_HEIGHT = 56;
export var TABS_HEIGHT = 50;
export var HEADER_MAX_WIDTH = 1800;
export var MIN_WIDTH_TO_SHOW_FULL_DRAWER = 1400;
export var LIST_MAX_WIDTH = 1800;
export var SIDEBAR_WIDTH = 60;
export var ZIndexGlobal = {
    MainActionBar: 1100,
    Header: 1002
};
